import { isClinro } from '@/config';
const apiPrefix = isClinro ? 'web' : 'api';
const baseAuth = '/api/auth/';
const baseIdentity = '/api/services/identity/v1/auth/';
const baseIdentityServices = '/api/services/identity';
const baseSchedule = '/api/services/scheduling/v1/';
const baseCapture = `/${apiPrefix}/services/data-capture/v1/`;
const baseStudyExperience = '/api/services/study-experience';
const baseNmible = '/api/services/nmible';
const baseTimeWarp = '/api/services/testing/time-warp';
export const UMOTIF_API = {
    AUTH: {
        LOGIN: `${baseAuth}token`,
        ME: `${baseAuth}participant/me`,
        PASSWORD_FORGOT: `${baseAuth}forgotten-password`,
        PASSWORD_RESET: `${baseAuth}password/reset`,
        REFRESH_TOKEN: `${baseAuth}token`,
        REGISTER: `${baseAuth}participant/register`,
        VALIDATE_INVITE_CODE: (code) => `${baseAuth}invitation/${code}/check`
    },
    CONFIG: {
        GET_APP_CONFIG: '/configuration/app'
    },
    DATA_CAPTURE: {
        CACHED_QUERY_MANY: `${baseCapture}cached-query/custom/execute/many`,
        CACHED_QUERY_SINGLE: `${baseCapture}cached-query/custom/execute/single`,
        EVENT_SUBMISSION_CHECK: ({ user_event_id, participant_id }) => `${baseCapture}event-submission-check?user_event_id=${user_event_id}${isClinro && participant_id ? `&participant_id=${participant_id}` : ''}`,
        GET_LATEST_SOURCED_DATA: `${baseCapture}latest-sourced-data`,
        GET_QUESTIONNAIRE: `${baseCapture}get-configurations`,
        POST_OVERLAP: `${baseCapture}overlap`,
        POST_PARTIALS: `${baseCapture}post-partials`,
        POST_START_UPLOAD: `${baseCapture}start-upload`,
        POST_SUBMISSIONS: `${baseCapture}post-submissions`,
        GET_PARTIAL: (id) => `${baseCapture}get-partials/${id}`
    },
    NMIBLE: {
        GET_STATUS: `${baseNmible}/get-status`,
        GET_PAYMENT_METHODS: `${baseNmible}/payment-methods`,
        SET_PAYMENT_METHOD: `${baseNmible}/set-payment-method`,
        SHOW_VIRTUAL_CARD: `${baseNmible}/show-virtual-card`,
        UPDATE_USER_STATUS: `${baseNmible}/update-user-status`
    },
    IDENTITY: {
        GET_TOKEN: `${baseIdentity}exchange-code-for-token`,
        IDPS: `${baseIdentity}idps`,
        SIGNATURE_SIGN: `${baseIdentityServices}/signatures/sign`
    },
    SCHEDULING: {
        CURRENT_USER_PHASE_EVENTS: `${baseSchedule}current-user-phase-and-events`,
        LIGHT_REPORT_DETAIL: (eventId) => `${baseSchedule}events/${eventId}/light-report/detail`,
        LIGHT_REPORT_LIST: (eventId) => `${baseSchedule}events/${eventId}/light-report/list`
    },
    STUDY_EXPERIENCE: {
        PROFILE: `${baseStudyExperience}participant/profile`
    },
    TESTING: {
        GET_TIME_WARP_STATUS: `${baseTimeWarp}/status`,
        PUT_TIME_WARP_BLINK: `${baseTimeWarp}/blink`,
        PUT_TIME_WARP_SHIFT: `${baseTimeWarp}/shift`
    }
};
export default UMOTIF_API;
